import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <footer className="site-footer">
        <div className="container">
          <div className="newsletter-box"></div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="footer-logo">
                <img src="assets/website/img/white-logo.png" />
              </div>
              <p>
                Become a market force — learn, strategise and win with India's
                most trusted stock market academy. Educational training only;
                not investment advice.
              </p>
              <div className="social-row mt-3">
                <a
                  href="https://www.facebook.com/profile.php?id=61592271246836"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener"
                >
                  <i className="fa-brands fa-facebook-f" />
                </a>
                <a
                  href="https://instagram.com/"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noopener"
                >
                  <i className="fa-brands fa-instagram" />
                </a>
                <a
                  href="https://youtube.com/"
                  aria-label="YouTube"
                  target="_blank"
                  rel="noopener"
                >
                  <i className="fa-brands fa-youtube" />
                </a>
                <a
                  href="https://t.me/"
                  aria-label="Telegram"
                  target="_blank"
                  rel="noopener"
                >
                  <i className="fa-brands fa-telegram" />
                </a>
              </div>
            </div>
            <div className="col-lg-2 col-6 mb-4 ">
              <h5>Company</h5>
              <ul>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <Link to="/privacy_policy">Privacy Policy</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-6 mb-4">
              <h5>Courses</h5>
              <ul>
                <li>
                  <Link to="/master_courses">Master Course</Link>
                </li>
                <li>
                  <Link to="/weekend_courses">Weekend Crash Course</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 mb-4 cus-fafa-054">
              <h5>Call Us Free</h5>
              <p
                className="text-accent-light"
                style={{ fontSize: "1.15rem", fontWeight: 700 }}
              >
                <i className="fa fa-phone"></i>
                +91 7004654910
              </p>
              <div className="cus-jamtara-4566" style={{ fontSize: ".85rem" }}>
                <i className="fa fa-map-marker"></i>
                <p className="cus-footer-address-541">
                  AMRIT PLAZA, JAMTARA ROAD, NIRSA, DHANBAD, JHARKHAND, 828205
                </p>
              </div>

              <p style={{ fontSize: ".85rem" }}>
                <i className="fa fa-envelope"></i>
                learning2earningsupport@gmail.com
              </p>
            </div>
          </div>
          <div className="disclosure-box">
            <strong>Important Disclosure:</strong> Learning 2 Earning Academy
            (L2E) is an educational institute that provides training programs on
            stock markets, forex, derivatives, options, and financial literacy.
            We are not a SEBI-registered advisor or research analyst, and we do
            not provide stock tips, buy/sell recommendations, investment advice,
            portfolio management, or brokerage services. All courses and
            training sessions are strictly for educational and informational
            purposes only. Trading and investing in financial markets involves
            risk of capital loss; past performance does not guarantee future
            results. Please consult a licensed financial advisor before making
            investment decisions.
          </div>
          <div className="footer-bottom text-center">
            <span>© Learning 2 Earning Academy. All Rights Reserved.</span>
          </div>
        </div>
      </footer>
    </>
  );
}
